exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-6cb14b8f]{width:800px;margin:50px auto 0}.stepOne-form[data-v-6cb14b8f]{width:360px;margin:50px auto 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6cb14b8f&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pc/stepOne.vue
// module id = 160
// module chunks = 0